import Lottie from 'lottie-web'
import {useState, useEffect, useRef} from 'react'

export const useLottie = (lottieRef: { current: any }, params: IObject, startLoad = true) => {
    const anim = useRef<any>(null)
    const [loadFinish, setLoadFinish] = useState(false)
    useEffect(() => {
        loadLottie()
        return () => {
            anim.current?.destroy()
            anim.current = null
        }
    }, [startLoad])
    const loadLottie = () => {
        if (!startLoad || anim.current?.isLoaded) return
        anim.current = Lottie.loadAnimation({
            container: lottieRef.current,
            renderer: 'svg',
            loop: false,
            autoplay: false,
            path: '',
            ...params,
        })
    }
    useEffect(() => {
        if (anim && params.speed) {
            anim.current?.setSpeed(params.speed)
        }
        if (anim && params.direction) {
            anim.current?.setDirection(params.direction)
        }
        if (anim && anim.current?.addEventListener) {
            anim.current?.addEventListener('data_ready', () => {
                setLoadFinish(true)
            })
        }
        return () => {
            anim?.current?.removeEventListener('data_ready')
        }
    }, [anim.current, params])
    return [
        anim.current,
        loadFinish,
        loadLottie,
        anim,
    ]
}
